import { DiscountsListState, DiscountListItem } from "app/pages/DiscountsList/modules/DiscountItemsList/state";
import { DiscountListFilters } from "app/shared/api/getDiscountList";
import { DiscountStatus } from "app/shared/model/DiscountType";
import { ProductStatusFilterValue } from "app/shared/components/productStatusFilterUtils";

function getRoot(state: any): DiscountsListState {
    return state.discountItemsList;
}

function isInactiveDiscount(item: DiscountListItem): boolean {
    return item.discountStatus.status === DiscountStatus.Expired;
}

export function getDiscountsToDisplay(state: any) {
    const root = getRoot(state);
    const list = root.discountsToDisplay;
    if (root.statusFilter === 'inactive') {
        return list.filter(isInactiveDiscount);
    }
    return list;
}

export function getSearchTerm(state: any) {
    const root = getRoot(state);
    return root.searchTerm;
}

export function getStatusFilter(state: any): ProductStatusFilterValue {
    return getRoot(state).statusFilter;
}

export function getTypeFilter(state: any): string[] {
    return getRoot(state).typeFilter;
}

export function getSchoolFilter(state: any): string[] {
    return getRoot(state).schoolFilter;
}

export function getSortOrder(state: any): string {
    return getRoot(state).sortOrder;
}

export function getAllSchools(state: any) {
    return getRoot(state).allSchools;
}

export function getDiscountFilters(state: any): DiscountListFilters {
    const root = getRoot(state);
    return {
        showAll: root.statusFilter !== 'active',
        types: root.typeFilter.length > 0 ? root.typeFilter : undefined,
        schoolIds: root.schoolFilter.length > 0 ? root.schoolFilter : undefined,
        sortOrder: root.sortOrder
    };
}